import lazyLoadView from "@router-utils/lazyload-view";
import routeError from "@router-utils/route-error";
import store from '@store'
import { getStoreOption } from "@utils/ipetbooking-options";
import { getDefaultCategory } from "@utils/ipetbooking-get-default";

export default [
  // ===
  // 分店
  // ===
  {
    path: '/store/:storeAlias',
    name: 'store',
    component: () => lazyLoadView(import('@views/Store/Index.Jtails')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          if(store.getters['auth/isLoggedIn']) {
            await store.dispatch('auth/fetchMemberPetList', {
              useCached: true
            });
          }

          const [
            currentService
          ] = await Promise.all([
            store.dispatch('merchant/fetchReservationPrice', {
              storeAlias: routeTo.params.storeAlias,
              categoryAlias: getDefaultCategory(routeTo.query.serviceCategory),
              types: ['cosmetic']
            }),
          ]);

          routeTo.params.serviceList = currentService.items;

          const currentStoreItem = getStoreOption({
            value: routeTo.params.storeAlias,
            type: 'item'
          });

          const hasStore = currentStoreItem && Object.keys(currentStoreItem).length > 0;

          if(hasStore) {
            routeTo.params.storeItem = currentStoreItem;
          } else {
            return next({
              name: '404'
            })
          }

          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404' }), next);
        }
      },
    },
    props: (route) => ({
      storeItem: route.params.storeItem || {},
      serviceList: route.params.serviceList || []
    }),
  },
]
